import { render } from "./lead-source-modal.vue?vue&type=template&id=2145e642"
import script from "./lead-source-modal.vue?vue&type=script&lang=js"
export * from "./lead-source-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__